import { useEffect } from 'react';
import { usePurchaseOrderMainCommentForm } from '@/features/purchase-order/hooks/use-purchase-order-main-comment-form';
import type { PurchaseOrderCommentValues } from '@/features/purchase-order/schema/purchase-order-comment-schema';
import { apiValidationErrorHandler } from '@/lib/api-validation-error-handler';
import { useEditPurchaseOrderComment } from '@/services/apis/mutations/purchase-orders/use-edit-purchase-order-comment';
import type { PurchaseOrderComment } from '@/types/core/purchase-order/purchase-order-comment';

type PurchaseOrderCommentEditProps = {
  purchaseOrderId: string;
  comment: PurchaseOrderComment;
  setOpen: (value: boolean) => void;
};

export function usePurchaseOrderMainCommentEdit({
  purchaseOrderId,
  comment,
  setOpen,
}: PurchaseOrderCommentEditProps) {
  const { control, handleSubmit, setError, reset } =
    usePurchaseOrderMainCommentForm(comment);
  const { mutate, isPending } = useEditPurchaseOrderComment(purchaseOrderId);

  const onSubmit = (data: PurchaseOrderCommentValues) => {
    mutate(data, {
      onSuccess: () => {
        setOpen(false);
      },
      onError: apiValidationErrorHandler(setError),
    });
  };

  useEffect(() => {
    reset(comment);
  }, [comment, reset]);

  return {
    control,
    handleSubmit,
    onSubmit,
    isSubmitting: isPending,
    reset,
  };
}
